/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
@import "../../scss/vars";

:host {
  .tabular-action-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: end;
    flex-direction: row;

    button {
      background-color: transparent;
      border: none;
      cursor: pointer;
      color: rgb(102, 102, 102);
      padding-top: 10px;

      &:hover {
        color: rgb(62, 152, 197);
      }
    }

    .tabular-export-csv {

    }
  }
  .tabular-wrapper {
    width: calc(100% - 20px);
    height: calc(100% - 50px);
    position: relative;
    overflow-y: auto;
    margin: 0;
    padding: 10px;

    .tabular-wrapper-inner {
      position: absolute;
      width: calc(100% - 20px);
      left: 10px;
      right: 0;
      bottom: 0;
      top: 0;
    }


  }
}
